import { createSelector } from 'reselect'

const bulkToolbarSelector = (state) => state.bulkToolbar || {}

export const isBulkToolbarOpenSelector = createSelector(
  bulkToolbarSelector,
  ({ is_open: isOpen }) => Boolean(isOpen)
)
